<scitis-app-global-page-header [pageTitle]="'Users'">
</scitis-app-global-page-header>

<div class="card mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th scope="col" class="sortable" style="width: 140px;" sortable="agreementAccepted"
              (sort)="onColumnSort($event)"><span translate>Name</span>
            </th>
            <th scope="col" class="sortable" sortable="displayName" (sort)="onColumnSort($event)"><span
            translate>E-Mail</span>
          </th>
          <th scope="col" class="sortable" sortable="username" (sort)="onColumnSort($event)"><span translate>Role</span>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (user of users; track user) {
        <tr>
          <td [innerText]=" user.displayName"></td>
          <td [innerText]=" user.username"></td>
          <td [innerText]=" user.role"></td>
        </tr>
      }
    </tbody>
  </table>
</div>
</div>
</div>

<scitis-page-summary [itemsCount]="users.length"
  [singleItemText]="translate.instant('User')"
  [multipleItemsText]="translate.instant('Users')">
</scitis-page-summary>
